/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applyrecurrence1Inputs */

const en_applyrecurrence1 = /** @type {(inputs: Applyrecurrence1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply recurrence`)
};

const de_applyrecurrence1 = /** @type {(inputs: Applyrecurrence1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholung anwenden`)
};

/**
* | output |
* | --- |
* | "Apply recurrence" |
*
* @param {Applyrecurrence1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const applyrecurrence1 = /** @type {((inputs?: Applyrecurrence1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applyrecurrence1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_applyrecurrence1(inputs)
	return de_applyrecurrence1(inputs)
});
export { applyrecurrence1 as "applyRecurrence" }